import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ComponentConfigPage from './ComponentConfig.page';
export const ComponentConfigRouter = () => (React.createElement(Routes, null,
    React.createElement(Route, { path: "/:componentId", element: React.createElement(ComponentConfigPage, null) })));
